<script>
    import { getContext } from "svelte" 
    import { alerts, token } from '../store'
    import {
        Alert,
        Container,
        Col,
        Row
    } from "sveltestrap"
    import axios from 'axios';

    let apiUrl = getContext("apiUrl");
</script>

<Container fluid>
    <Row>
        <Col lg="4"  md="3" sm="2" xs="1"></Col>
        <Col lg="4" md="6" sm="8" xs="10">
            {#each $alerts as alert}
                {#if alert.type == "bootstrap"}
                    {#if alert.dismissible == "1"}
                        <Alert color={alert.color} isOpen={alert.visible} toggle={() => {
                            alert.visible = false;
                            axios.get(apiUrl + "closeAlert.php", {
                                "params": {
                                    "id": alert.alert_id,
                                    "token": $token
                                }
                            })
                        }}>
                            {alert.content}
                        </Alert>
                    {:else}
                        <Alert color={alert.color}>
                            {alert.content}
                        </Alert>
                    {/if}
                {/if}
            {/each}
        </Col>
        <Col lg="4"  md="3" sm="2" xs="1"></Col>
    </Row>
</Container>